import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { showToast } from '../../components/Toast/Toast';
import { ToastTypes } from '../../components/Toast/Toast.types';
import useNavigateWithToast from '../useNavigateWithToast/useNavigateWithToast';
import { StyledAnchor } from './useGenericErrorMessage.styles';

export const genericErrorShowToastOptions = {
  label: 'Something went wrong.',
  id: 'errorToast',
  toastType: ToastTypes.Error,
  subtext: (
    <>
      <div>
        For immediate assistance, please contact{' '}
        <StyledAnchor href='mailto:ManageMenu@yum.com'>ManageMenu@yum.com</StyledAnchor>.
      </div>
      <div>Otherwise contact the Manage Menu team via the options listed below:</div>
    </>
  ),
  buttonLabel: 'Manage Menu Product Lane - Confluence',
  onButtonClick: () => {
    window.location.replace(
      'https://pizzahut.atlassian.net/wiki/spaces/MMPL/overview#:warning:-Production-Support-Issues'
    );
  },
};

export const useGenericErrorMessage = (errors: { isError: boolean; error: unknown }[], navigateTo?: string) => {
  const navigateWithToast = useNavigateWithToast();  useEffect(() => {
    const errorsToHandle = errors.filter((error) => {
      if (error.isError === false) return false;
      if ((error.error as AxiosError)?.message === 'apiGatewayTimeout') return false;
      return true;
    });
    if (errorsToHandle.length === 0) return; // no error exists
    if (navigateTo) {
      navigateWithToast(navigateTo, genericErrorShowToastOptions);
    } else {
      showToast(genericErrorShowToastOptions);
    }
  }, [errors, navigateTo, navigateWithToast]);
};
